import React from 'react';
import { Award } from 'lucide-react';
import paypalLogo from '../../assets/images/payment/paypal.png';
import applePayLogo from '../../assets/images/payment/apple-pay.png';
import samsungPayLogo from '../../assets/images/payment/samsung-pay.png';
import visaLogo from '../../assets/images/payment/visa.png';
import mastercardLogo from '../../assets/images/payment/mastercard.png';
import { PaystackStripeBrand } from './PaymentProviderBrand';

export default function CheckoutTrustSection({ paystackVisible = true }) {
  return (
    <div className="mt-6 rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm sm:px-5 sm:py-5">
      <div className="flex items-start gap-3 mb-4">
        <span
          className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-50 ring-1 ring-blue-100"
          aria-hidden
        >
          <Award className="h-[18px] w-[18px] text-blue-600" strokeWidth={2.25} />
        </span>
        <p className="text-[13px] sm:text-sm text-slate-600 leading-relaxed text-left">
          Cognidoor&apos;s payments are processed by{' '}
          <strong className="font-semibold text-slate-800">PayPal</strong>
          {paystackVisible ? (
            <>
              {' '}and{' '}
              <strong className="font-semibold text-slate-800">Paystack</strong>, a Stripe company.
            </>
          ) : (
            '.'
          )}
          {' '}Your access is granted only after payment is verified on our servers.
        </p>
      </div>

      <div className="flex flex-col items-center gap-3 mb-4">
        <img src={paypalLogo} alt="PayPal" className="h-7 w-auto max-w-[140px] object-contain" />
        {paystackVisible ? (
          <PaystackStripeBrand size="md" className="text-slate-700" />
        ) : null}
      </div>

      <p className="text-center text-xs font-medium text-slate-500 uppercase tracking-wide mb-3">
        Accepted payment methods
      </p>
      <div className="flex items-center justify-center gap-3 sm:gap-4 flex-wrap opacity-90">
        <img src={applePayLogo} alt="Apple Pay" className="h-5 w-auto object-contain max-h-5" />
        <img src={samsungPayLogo} alt="Samsung Pay" className="h-5 w-auto object-contain max-h-5" />
        <img src={visaLogo} alt="Visa" className="h-5 w-auto object-contain max-h-5" />
        <img src={mastercardLogo} alt="Mastercard" className="h-5 w-auto object-contain max-h-5" />
        <img src={paypalLogo} alt="PayPal" className="h-5 w-auto object-contain max-h-5" />
      </div>

      <p className="mt-4 text-[11px] sm:text-xs text-slate-500 text-center leading-relaxed">
        One-time purchase only. Cognidoor does not auto-renew or charge recurring payments.
      </p>
    </div>
  );
}
